module.exports = __webpack_public_path__ + "static/media/hello-kitty-activation.6a860658.png";